import { Expose } from 'class-transformer';

import { Model } from './model';

export class CallsDetailsReport extends Model {
  @Expose() totalCanceledUnknownTypeCalls: number;
  @Expose() totalCanceledVideoCalls: number;
  @Expose() totalCanceledVoiceCalls: number;
  @Expose() totalCompletedUnknownTypeCalls: number;
  @Expose() totalCompletedVideoCalls: number;
  @Expose() totalCompletedVoiceCalls: number;
  @Expose() totalDeniedUnknownTypeCalls: number;
  @Expose() totalDeniedVideoCalls: number;
  @Expose() totalDeniedVoiceCalls: number;
  @Expose() totalFailedUnknownTypeCalls: number;
  @Expose() totalFailedVideoCalls: number;
  @Expose() totalFailedVoiceCalls: number;
  @Expose() totalNoAnswerUnknownTypeCalls: number;
  @Expose() totalNoAnswerVideoCalls: number;
  @Expose() totalNoAnswerVoiceCalls: number;
  @Expose() totalNoneUnknownTypeCalls: number;
  @Expose() totalNoneVideoCalls: number;
  @Expose() totalNoneVoiceCalls: number;
  @Expose() totalTimeOutUnknownTypeCalls: number;
  @Expose() totalTimeOutVideoCalls: number;
  @Expose() totalTimeOutVoiceCalls: number;
  @Expose() totalUnknownTypeCalls: number;
  @Expose() totalVideoCalls: number;
  @Expose() totalVoiceCalls: number;
  @Expose() totalVoiceMinutes: number;
  @Expose() totalVideoMinutes: number;
  @Expose() totalCompletedVoiceMinutes: number;
  @Expose() totalCompletedVideoMinutes: number;
  @Expose() totalFailedVoiceMinutes: number;
  @Expose() totalFailedVideoMinutes: number;
  @Expose() totalNoAnswerVoiceMinutes: number;
  @Expose() totalNoAnswerVideoMinutes: number;
  @Expose() totalNoneVoiceMinutes: number;
  @Expose() totalNoneVideoMinutes: number;
  @Expose() totalTimeOutVoiceMinutes: number;
  @Expose() totalTimeOutVideoMinutes: number;
  @Expose() totalDeniedVoiceMinutes: number;
  @Expose() totalDeniedVideoMinutes: number;
  @Expose() totalCanceledVoiceMinutes: number;
  @Expose() totalCanceledVideoMinutes: number;
}
